<template>
  <div class="baiduQueue">
    <div class="head">
      <img src="/static/index/index1.png" alt="" />
      <div class="h0">
        <div class="h1"></div>
        <!-- <div class="h2">
          <div class="h21">
            <el-input v-model="input" @keyup.enter.native="search" placeholder="输入品牌/型号"></el-input>
          </div>
          <div class="h22" @click="search">查询</div>
        </div> -->
      </div>
    </div>
    <div class="b2">
      <div class="b25">
        <!-- 视频标题和发布时间 -->
        <div class="video-header">
          <h1 class="video-title">{{ name }}</h1>
          <div class="video-meta">
            <span>发布时间: {{ formatDate(createTime) }}</span>
            <!-- <span class="view-count">点击量: {{ viewCount || '285' }}</span> -->
          </div>
        </div>

        <!-- 视频播放区域 -->
        <div class="bilibili-video">
          <div class="video-container">
            <iframe :src="bilibiliUrl" scrolling="no" border="0" frameborder="no" framespacing="0"
              allowfullscreen="true"></iframe>
          </div>
        </div>

        <!-- 导航按钮 -->
        <div class="navigation-buttons">
          <div class="back-button" @click="goBack">
            <img src="/static/index/index5.png" alt="">
            <span>返回列表</span>
          </div>
          <div class="next-button" @click="goNext" v-if="nextId">
            <span>下一篇: {{ nextTitle || '' }}</span>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>

        <!-- 相关视频列表 -->
        <div class="related-videos">
          <h2 class="related-title">相关视频</h2>
          <div class="related-videos-grid">
            <div class="related-video-card" v-for="(item, index) in treeList_" :key="index"
              @click="viewRelatedVideo(item)" :class="{ 'active': item.id == $route.query.id }">
              <div class="related-thumbnail">
                <img :src="item.imgUrl" alt="">
                <div class="play-icon">
                  <i class="el-icon-video-play"></i>
                </div>
              </div>
              <div class="related-info">
                <div class="related-title">{{ item.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer1></footer1>
  </div>
</template>

<script>
import Cookie from "js-cookie";

export default {
  title: "视频详情",
  data() {
    return {
      name: "",
      bilibiliUrl: "",
      createTime: "",
      viewCount: "",
      nextId: null,
      nextTitle: "",
      treeList_: []
    };
  },
  computed: {},
  components: {},
  mounted() {
    this.getData(this.$route.query.id);
    this.getListData(this.$route.query.id);
  },
  methods: {
    getData(id) {
      this.$axios.post('/get_web_video', this.$qs.stringify({ id })).then(res => {
        this.name = res.data.data.name;
        this.bilibiliUrl = res.data.data.videoCode;
        this.createTime = res.data.data.createTime;
      })
    },

    getListData(id) {
      this.$axios
        .post("/do_web_video", this.$qs.stringify({ typeId: this.$route.query.typeId }))
        .then((res) => {
          console.log(res);
          this.treeList_ = res.data.data.rows

          if (this.treeList_.length > 0) {
            for (let i = 0; i < this.treeList_.length; i++) {
              if (this.treeList_[i].id == id) {
                var tempIndex = i + 1;
                if (tempIndex < this.treeList_.length) {
                  this.nextId = this.treeList_[tempIndex].id
                  this.nextTitle = this.treeList_[tempIndex].name
                } else {
                  this.nextId = this.treeList_[0].id
                  this.nextTitle = this.treeList_[0].name
                }
              }
            }
          }
        });

    },

    // 添加时间格式化方法
    formatDate(timestamp) {
      if (!timestamp) return '';

      // 将时间戳转换为日期对象
      const date = new Date(parseInt(timestamp));

      // 格式化为 YYYY-MM-DD 格式
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    },

    goBack() {
      this.$router.push('/webVideo');
    },
    goNext() {
      if (this.nextId) {
        this.getData(this.nextId);
        this.getListData(this.nextId);
      }
    },

    viewRelatedVideo(item) {
      if (item.id == this.$route.query.id) return; // 如果是当前视频，不执行操作

      // 更新路由但不刷新页面
      this.$router.push({
        path: '/webVideoDetails',
        query: {
          id: item.id,
          typeId: this.$route.query.typeId
        }
      });

      // 加载新视频数据
      this.getData(item.id);
      this.getListData(item.id);

      // 滚动到页面顶部
      window.scrollTo(0, 0);
    }
  },
};
</script>

<style lang="scss" scoped>
.baiduQueue {
  width: 100%;
  height: 100%;
  overflow-y: auto;

  // min-height: 940px;
  // display: flex;
  // flex-direction: column;
  .head {
    width: 100%;
    height: 470px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 0;
    }

    .h0 {
      width: 1200px;
      z-index: 1;

      .h1 {
        font-size: 46px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #ffffff;
        margin-bottom: 58px;
        text-align: center;
      }

      .h2 {
        width: 922px;
        height: 78px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #ffffff;
        border-radius: 6px;
        margin: 0 auto;

        .h21 {
          padding-left: 30px;
          width: 80%;

          .el-input {
            width: 80%;
          }

          /deep/ .el-input__inner {
            border: none;

            font-size: 24px;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #999999;
          }
        }

        .h22 {
          width: 208px;
          height: 78px;
          background: #ff5602;
          border-radius: 6px;
          text-align: center;
          line-height: 78px;
          font-size: 24px;
          font-family: SourceHanSansCN-Bold, SourceHanSansCN;
          font-weight: bold;
          color: #ffffff;
        }
      }
    }
  }

  .b2 {
    width: 1200px;
    background: #FFFFFF;
    margin: 0 auto;
    min-height: 1000px;

    .b21 {
      display: flex;
      align-items: center;
      height: 60px;
      width: 100%;

      div {
        width: 20%;
        height: 60px;
        background: #F3F3F3;
        text-align: center;
        line-height: 60px;
        font-size: 20px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #333333;
      }

      .b211 {
        background: #FFFFFF;
        color: #198AFA;
      }

    }

    .b22 {
      padding-top: 30px;

      &>div {
        display: flex;
        align-items: center;
        width: 1200px;
        height: 120px;
        background: #FFFFFF;
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
        border-radius: 6px;
        margin: 0 auto 20px;
        padding: 0 7px;

        img {
          width: 120px;
          height: 108px;
          margin-right: 32px;
        }

        &>div {
          width: calc(100% - 166px);

          .b221 {
            font-size: 24px;
            font-family: SourceHanSansCN-Medium, SourceHanSansCN;
            font-weight: 500;
            color: #333333;
          }

          .b222 {
            font-size: 20px;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #999999;
            margin-top: 14px;
          }
        }
      }
    }

    .b23 {
      padding-top: 30px;

      .b231 {
        display: flex;
        align-items: center;
        width: 1174px;
        height: 120px;
        background: #FFFFFF;
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
        border-radius: 6px;
        margin: 0 auto 20px;
        padding: 0 13px;

        img {
          width: 97px;
          height: 98px;
          margin-right: 39px;
        }

        .b2311 {
          width: calc(100% - 300px);
          font-size: 24px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          font-weight: 500;
          color: #333333;
        }

        .b2312 {
          width: 72px;
          height: 30px;
          border-radius: 15px;
          border: 1px solid #979797;
          text-align: center;
          line-height: 30px;
          cursor: pointer;

        }

        .b2313 {
          margin-right: 10px;
        }
      }

      .b232 {
        width: 128px;
        height: 48px;
        border-radius: 24px;
        border: 1px solid #CCCCCC;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 30px;
        margin-left: 447px;

        img {
          width: 25px;
          height: 20px;
        }

        div {
          font-size: 20px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          font-weight: 500;
          color: #999999;
          margin-left: 6px;

        }
      }

    }

    .b25 {
      padding-top: 30px;
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        width: 100%;
      }

      .web-url {
        padding: 20px;
        font-size: 20px;

        span {
          color: #333;
          font-weight: 500;
        }

        a {
          color: #198AFA;
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }
        }
      }

      .video-header {
        width: 100%;
        max-width: 860px;
        margin-bottom: 20px;

        .video-title {
          font-size: 28px;
          font-weight: 600;
          color: #333;
          margin-bottom: 15px;
          text-align: center;
        }

        .video-meta {
          display: flex;
          justify-content: center;
          color: #999;
          font-size: 14px;

          span {
            margin: 0 10px;
          }
        }
      }

      .bilibili-video {
        margin: 20px 0;
        width: 100%;
        max-width: 860px;

        .video-container {
          position: relative;
          width: 100%;
          height: 0;
          padding-bottom: 56.25%;
          /* 16:9 宽高比 */

          iframe {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border-radius: 8px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          }
        }
      }

      .navigation-buttons {
        width: 100%;
        max-width: 860px;
        display: flex;
        justify-content: space-between;
        margin-top: 30px;
        padding: 0 10px;

        .back-button {
          display: flex;
          align-items: center;
          cursor: pointer;
          padding: 8px 15px;
          border-radius: 4px;
          background: #f5f5f5;

          img {
            width: 20px;
            height: 16px;
            margin-right: 8px;
          }

          span {
            font-size: 16px;
            color: #666;
          }

          &:hover {
            background: #e8e8e8;
          }
        }

        .next-button {
          display: flex;
          align-items: center;
          cursor: pointer;
          padding: 8px 15px;
          border-radius: 4px;
          background: #f5f5f5;
          max-width: 60%;

          span {
            font-size: 16px;
            color: #666;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          i {
            margin-left: 8px;
            color: #666;
          }

          &:hover {
            background: #e8e8e8;
          }
        }
      }

      .related-videos {
        width: 100%;
        max-width: 1200px;
        margin-top: 50px;

        .related-title {
          font-size: 24px;
          font-weight: 600;
          color: #333;
          margin-bottom: 20px;
          text-align: center;
          position: relative;

          &:after {
            content: '';
            position: absolute;
            bottom: -10px;
            left: 50%;
            transform: translateX(-50%);
            width: 50px;
            height: 3px;
            background: #198AFA;
          }
        }

        .related-videos-grid {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          margin-top: 30px;
        }

        .related-video-card {
          width: 270px;
          margin: 0 15px 30px;
          cursor: pointer;
          transition: all 0.3s ease;
          background: #f9f9f9;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);

          &:hover {
            transform: translateY(-5px);
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);

            .play-icon {
              opacity: 1;
            }
          }

          &.active {
            border: 2px solid #198AFA;

            .related-info {
              background: #e6f2ff;
            }
          }

          .related-thumbnail {
            position: relative;
            width: 100%;
            height: 150px;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              transition: transform 0.3s ease;
            }

            .play-icon {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 40px;
              height: 40px;
              background: rgba(25, 138, 250, 0.8);
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              opacity: 0.7;
              transition: opacity 0.3s ease;

              i {
                color: white;
                font-size: 20px;
              }
            }
          }

          .related-info {
            padding: 12px;

            .related-title {
              font-size: 14px;
              font-weight: 500;
              color: #333;
              line-height: 1.4;
              height: 40px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              text-align: left;
              margin: 0;

              &:after {
                display: none;
              }
            }
          }
        }
      }
    }

    .b24 {
      padding-top: 30px;

      &>div {
        width: 494px;
        height: auto;
        background: #FFFFFF;
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
        border-radius: 6px;
        padding: 16px 33px;
        margin: 0 auto;

        .b241 {
          display: flex;
          align-items: center;
          margin-bottom: 10px;

          img {
            width: 40px;
            height: 40px;
            margin-right: 17px;
          }

          div {
            font-size: 24px;
            font-family: SourceHanSansCN-Medium, SourceHanSansCN;
            font-weight: 600;
            color: #333333;
          }
        }

        .b242 {
          font-size: 20px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #999999;
        }
      }
    }
  }



}
</style>


// WEBPACK FOOTER //
// src/pages/webVideo/details.vue